import React from 'react';
import { Flex, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { OptionsButtonsProps } from '../../interfaces/layout/Header/optionsButtons';
import { useRouteHelper } from '../../../hooks/routesHelpers';
import { useDetectIsLandingPage } from '../../../helpers/getIsLandingPage';
import OwnerAdvantegesBanner from '../../landingPage/OwnerAdvantegesBanner';

export default function OptionsButtons({ isMobile, isHeroSection, noMarginBottom }: OptionsButtonsProps) {
  const { t } = useTranslation();
  const { setRoute } = useRouteHelper();
  const location = useLocation();
  const searchPageRoute = setRoute('search.property');
  const isSearchpage = location?.pathname === searchPageRoute;
  const isLandingPage = useDetectIsLandingPage();

  return (
    <Flex
      alignItems="center"
      mx="auto"
      display={!isMobile ? { base: 'none', md: 'flex' } : 'flex'}
      justifyContent={isMobile ? 'center' : ''}
      bg={isMobile && isLandingPage ? '#F3F6F7' : 'transparent'}
      w={isMobile && isLandingPage ? 'fit-content' : 'unset'}
      p={isMobile && isLandingPage ? '8px' : 'unset'}
      borderRadius={isMobile && isLandingPage ? '5px' : 'unset'}
      position="relative"
      mb={isMobile && !noMarginBottom ? '65px' : 'unset'}
    >
      <RouterLink to={`${setRoute('search.property')}/?p=1`}>
        {!isHeroSection ? (
          <Button
            colorScheme={!isHeroSection ? 'brand' : 'white'}
            variant={isHeroSection ? 'link' : isSearchpage ? 'solid' : 'outline'}
            size="md"
            mr={isMobile && isLandingPage ? '5px' : '1em'}
            minW={{ base: '125px', md: '90px' }}
          >
            {t('header.searchBtn')}
          </Button>
        ) : (
          <Button
            colorScheme={!isHeroSection ? 'brand' : 'unset'}
            variant={isHeroSection ? 'link' : isSearchpage ? 'solid' : 'outline'}
            size="md"
            mr="1em"
            color={!isHeroSection ? '' : 'white'}
          >
            {t('header.searchBtn')}
          </Button>
        )}
      </RouterLink>
      <RouterLink to={setRoute('becomeAHost.propertyInformation')}>
        {!isHeroSection ? (
          <Button
            colorScheme={!isHeroSection ? 'brand' : 'unset'}
            variant={isHeroSection ? 'link' : isSearchpage ? 'outline' : 'solid'}
            size="md"
            minW={{ base: '125px', md: '90px' }}
          >
            {t('header.listBtn')}
          </Button>
        ) : (
          <Button
            colorScheme={!isHeroSection ? 'brand' : 'unset'}
            variant={isHeroSection ? 'link' : isSearchpage ? 'outline' : 'solid'}
            size="md"
            color={!isHeroSection ? '' : 'white'}
          >
            {t('header.listBtn')}
          </Button>
        )}
      </RouterLink>
      {isHeroSection && <OwnerAdvantegesBanner />}
    </Flex>
  );
}
